/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable camelcase */
import { useState, useEffect } from 'react';
import ModalHeader from 'components/core/modal-header';
import Markdown from 'markdown-to-jsx';
import { useRouter } from 'next/router';
import { CenterSpinner } from 'components/core/loading-spinner';
import { useUser } from 'contexts/user-context';
import SVG from 'assets/svgs';
import { GetFaQsQuery, useGetFaQsQuery } from 'graphpl/cms-types';
import {
  FAQWrapper,
  Question,
  Answer,
  Wrapper,
  InnerWrapper,
  HeaderWrapper,
  PageWrapper,
  Error,
  SectionHeader,
} from './index.styles';

interface ISortedList {
  id: string;
  label: string;
  data: GetFaQsQuery['fAQs'];
}

const markDownOptions = {
  overrides: {
    a: {
      component: ({ children, ...props }) => {
        return (
          <a target="_blank" rel="noopener noreferrer" {...props}>
            {children}
          </a>
        );
      },
    },
  },
};

const SortList = (data: GetFaQsQuery): ISortedList[] => {
  let faqs = data.fAQs;
  const sections = data.faqCategoriesConnection.edges.map<ISortedList>(
    (item) => ({
      id: item.node.faqCategory,
      label: item.node.displayName,
      data: [] as GetFaQsQuery['fAQs'],
    }),
  );
  sections.forEach((value, index) => {
    const temp: GetFaQsQuery['fAQs'] = [];
    const information = faqs.filter((faq) => {
      if (faq.faq_category === value.id) {
        return faq;
      }
      temp.push(faq);
    });
    faqs = temp;
    if (information.length <= 0) return;
    information.sort((a, b) => a.priority - b.priority);
    sections[index].data = information;
  });

  return sections.filter((value) => value.data.length > 0);
};

const FAQ: React.FC<{ faqId?: string }> = ({ faqId }) => {
  const router = useRouter();
  const { authenticated } = useUser();
  const [questionsDisplayed, setQuestionsDisplayed] = useState<string[]>([
    faqId,
  ]);
  const { data, error, loading } = useGetFaQsQuery({
    context: { clientName: 'cms' },
  });

  const goBack = (): void => {
    router.push(authenticated ? '/bet' : '/');
  };

  useEffect(() => {
    if (faqId && data) {
      document.getElementById(`#${faqId}`).scrollIntoView();
    }
  }, [data, faqId]);

  if (loading) {
    return (
      <>
        <ModalHeader title="Frequently asked questions" backOnClick={goBack} />
        <CenterSpinner size={80} />
      </>
    );
  }

  if (error) {
    return (
      <>
        <ModalHeader title="Frequently asked questions" backOnClick={goBack} />
        <Error>There was a problem</Error>
      </>
    );
  }

  const SECTION_DATA = !loading && data ? SortList(data) : [];

  return (
    <PageWrapper>
      <HeaderWrapper>
        <ModalHeader
          useNewFont
          title="Frequently asked questions"
          backOnClick={goBack}
        />
      </HeaderWrapper>

      <Wrapper>
        {SECTION_DATA.map((section) => {
          return (
            <>
              <SectionHeader>{section.label}</SectionHeader>
              {section.data.map((faq) => {
                const { answer, question, id } = faq;
                const faqIsSelected = questionsDisplayed.includes(id);

                const faqOnClick = (): void => {
                  if (faqIsSelected) {
                    const newSelected = questionsDisplayed.filter(
                      (questionId) => questionId !== id,
                    );
                    setQuestionsDisplayed(newSelected);
                  } else {
                    setQuestionsDisplayed([...questionsDisplayed, id]);
                  }
                };

                return (
                  <FAQWrapper id={`#${id}`} key={id}>
                    <InnerWrapper onClick={faqOnClick}>
                      <Question>{question}</Question>
                      <SVG
                        icon={
                          faqIsSelected
                            ? 'action:chevronUp'
                            : 'action:chevronDown'
                        }
                      />
                    </InnerWrapper>

                    {faqIsSelected && (
                      <Answer>
                        <Markdown options={markDownOptions}>{answer}</Markdown>
                      </Answer>
                    )}
                  </FAQWrapper>
                );
              })}
            </>
          );
        })}
      </Wrapper>
    </PageWrapper>
  );
};

export default FAQ;
